import APP from 'src/main.js'
import AppRecord from './AppRecord.js'

class EntityRelation extends AppRecord {
  get parent(){
    return this.constructor.employeeStore.entitiesById.get(this.parent_id)
  }
  get child(){
    return this.constructor.employeeStore.entitiesById.get(this.child_id)
  }
}

export default EntityRelation
